<template>
  <v-container>
    <v-card>
      <v-card-title>Статистика по сайтам</v-card-title>
      <v-card-text>
        <v-data-table
          class="elevation-2"
          :items="curStat"
          :headers="headers"
          :search="search"
        >
          <template v-slot:top> 
            <v-row class="m-0 p-0 ml-2 mr-2">
              <v-col cols="12" sm="6">
                <v-text-field
                  placeholder="Введите данные для поиска"
                  v-model="search"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  label="Период"
                  :items="statMonths"
                  v-model="period"
                ></v-select>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'sites-table',

  data() {
    return {
      search: '',
      period: 0,
      headers: [
        {
          text: 'Сайт',
          value: 'siteName'
        },
        {
          text: 'Кап.',
          value: 'large'
        },
        {
          text: 'Частичн.',
          value: 'medium'
        },
        {
          text: 'Мелкий',
          value: 'small'
        },
        {
          text: 'Дизайн',
          value: 'design'
        },
        {
          text: 'Не по теме',
          value: 'spam'
        },
        {
          text: 'Дубль',
          value: 'clone'
        },
        {
          text: 'Неразобрано',
          value: 'new'
        },
        {
          text: 'ВСЕГО',
          value: 'allCount'
        },
        {
          text: 'БАЛЛОВ',
          value: 'sumPoints'
        },
        {
          text: 'Аренда, руб',
          value: 'rentCF'
        },
        {
          text: 'За 1 балл, руб',
          value: 'costPerPoint'
        },
      ]
    }
  },

  created() {
    this.$store.dispatch('customers/loadStat').then(() => {
      this.period = this.statMonths.length - 1;
    });
  },
  
  computed: {
    ...mapGetters('customers', ['loadingStat', 'statMonths', 'statPerMonth']),
    ...mapState('customers', ['statWeights', 'statuses']),
    curStat() {
      if (this.statPerMonth.length > 0) {
        return this.statPerMonth[this.period].map(item => {
          let newItem = {
            ...item,
            sumPoints: this.statuses.reduce((sum, cur) => (sum + this.statWeights[cur.value] * item[cur.value]), 0)
          };
          newItem.costPerPoint = newItem.sumPoints > 0 ? Math.floor( newItem.rentCF / newItem.sumPoints ) : 'N/A';
          return newItem; 
        });
      } else {
        return [];
      }
    }
  }
}
</script>